// Estado da regra de exibição do modal de comunicados do portal (design, decisão 2).
// Fica em localStorage porque a regra vale para o login, que é compartilhado entre
// abas e sobrevive a recarregamentos. Módulo sem dependências: o AuthStore o usa no logout.

export const COMUNICADOS_PORTAL_STORAGE_KEY = 'pcv2:comunicados-portal'

// Sem storage (modo privado, bloqueio), lê null: o modal abre a cada visita, o que é aceitável.
export function lerEstadoPortal() {
  try {
    const bruto = localStorage.getItem(COMUNICADOS_PORTAL_STORAGE_KEY)
    const estado = bruto ? JSON.parse(bruto) : null
    if (!estado || typeof estado !== 'object' || !Array.isArray(estado.apresentados)) return null
    return estado
  } catch {
    return null
  }
}

export function gravarEstadoPortal(estado) {
  try {
    localStorage.setItem(COMUNICADOS_PORTAL_STORAGE_KEY, JSON.stringify(estado))
  } catch {
    // Sem storage disponível: segue sem memória entre visitas.
  }
}

export function limparEstadoPortal() {
  try {
    localStorage.removeItem(COMUNICADOS_PORTAL_STORAGE_KEY)
  } catch {
    // Sem storage disponível: nada a limpar.
  }
}
